import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import MultiActionModal from './multi-action-modal';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class ContentsHeader extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal : false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * モーダル操作
   */
  toggleModal(flg) {
    this.setState({ modal: flg });
  }
  // -------------------------------------------------------
  
  change() {
    this.props.set_ev.bind(this)(this.word.value);
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.base;
    
    let tabs = [
      { id: 'workflow', name: 'ワークフロー', icon: 'view_column' },
      { id: 'sheet',    name: 'シート',       icon: 'list_alt' },
    ];
    
    return (
      <div className="contents-header">
        
        <div className="tab-action">
          <h6>表示形式</h6>
          <ul className="work-tabs">
            { tabs.map((d, key) => {
              let flg = (d.id == this.props.work_tab) ? 'on' : 'off';
              return (
                <OverlayTrigger key={key} placement="top" delayShow={50} overlay={<Tooltip>{d.name}</Tooltip>}>
                  <li className={flg} onClick={this.props.tab_ev.bind(this, d.id)}>
                    <i className="material-icons">{d.icon}</i>
                  </li>
                </OverlayTrigger>
              );
            })}
          </ul>
        </div>
        
        <div className="multi-action">
          { (base.ng_view_mode == 'false')
            ? <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>アサインNGのインフルエンサーを非表示にします</Tooltip>}>
                <div className="action-item" onClick={this.props.ng_ev.bind(this, 'true')}>
                  <i className="material-icons">visibility</i>
                  <h6>NGを表示</h6>
                </div>
              </OverlayTrigger>
            : <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>アサインNGのインフルエンサーを表示します</Tooltip>}>
                <div className="action-item" onClick={this.props.ng_ev.bind(this, 'false')}>
                  <i className="material-icons">visibility_off</i>
                  <h6>NGを非表示</h6>
                </div>
              </OverlayTrigger>
          }
          
          <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>ワークフローに残したいメモを作成することができます</Tooltip>}>
            <div className="action-item" onClick={base.event.showMemoCreateModal.bind(this, null, '')}>
              <i className="material-icons">note_alt</i>
              <h6>メモ作成</h6>
            </div>
          </OverlayTrigger>
          
          <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>インフルエンサーのステータスを一括で変更できます</Tooltip>}>
            <div className="action-item" onClick={this.toggleModal.bind(this, true)}>
              <i className="material-icons">integration_instructions</i>
              <h6>一括操作</h6>
            </div>
          </OverlayTrigger>
        </div>
        
        <div className="search-box">
          <input className="text" type="text" ref={(input) => { this.word = input }} onChange={this.change.bind(this)} placeholder="名前を検索" />
          <i className="material-icons">search</i>
        </div>
        
        <MultiActionModal base={base} view={this.state.modal} close_ev={this.toggleModal.bind(this)} />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ContentsHeader;